import { render } from "./Total_statistics.vue?vue&type=template&id=de83ac8c&scoped=true"
import script from "./Total_statistics.vue?vue&type=script&lang=js"
export * from "./Total_statistics.vue?vue&type=script&lang=js"

import "./Total_statistics.vue?vue&type=style&index=0&id=de83ac8c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de83ac8c"]])

export default __exports__